import { Component, OnInit } from '@angular/core';
import { ItemVenda, Venda } from 'src/app/core/models/venda';
import { VendaService } from 'src/app/core/services/venda.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-lista-vendas',
  templateUrl: './lista-vendas.component.html',
  styleUrls: ['./lista-vendas.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ListaVendasComponent implements OnInit {
  vendas: Venda[] = [];
  itemVendas: ItemVenda[] = [];
  vendaSelecionada: Venda | null = null;

  constructor(
    private readonly servico: VendaService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  selecionar(): void {
    this.servico.listarVendasTop100().subscribe((retorno) => (this.vendas = retorno));
  }

  ngOnInit() {
    this.selecionar();
  }

  selecionarVenda(venda: Venda): void {
    this.vendaSelecionada = venda;
    this.itemVendas = venda.itens;
    console.log(this.vendaSelecionada);
  }

  cancelarVenda(venda: Venda): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja cancelar a venda ${venda.id}?`,
      header: 'Confirmação de Cancelamento',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (venda.id) {
          this.servico.cancelarVenda(venda.id).subscribe({
            next: () => {
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: `Venda ${venda.id} cancelada com sucesso!` });
              this.selecionar();
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.add({ severity: 'error', summary: 'Erro', detail: `Falha ao cancelar venda ${venda.id}: ${err.error?.message || err.message}` });
              console.error('Erro ao cancelar venda:', err);
            }
          });
        }
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Cancelado', detail: 'Cancelamento de venda abortado.' });
      }
    });
  }

  exportarPdf(venda: Venda, tipo: string = 'A4'): void {
    if (!venda?.id) return;
    this.servico.exportarPdf(venda.id, tipo).subscribe({
      next: (blob) => {
        const url = globalThis.URL.createObjectURL(blob);

        // Abrir em nova aba (inline). Pode ser bloqueado por pop-up blockers.
        globalThis.open(url, '_blank');

        // Forçar download também (garante que o arquivo será salvo mesmo se popup for bloqueado)
        const filename = `venda_${venda.id}_${tipo}.pdf`;
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        // revogar o objectURL depois de um tempo
        setTimeout(() => globalThis.URL.revokeObjectURL(url), 20000);
      },
      error: (err: HttpErrorResponse) => {
        console.error('Erro ao exportar PDF', err);
        alert('Falha ao exportar PDF.');
      }
    });
  }

}
